import {
  motion,
  useReducedMotion,
  useScroll,
  useTransform,
} from "framer-motion";
import { useRef, type ReactNode } from "react";

import { Band } from "./Ornaments";

/**
 * The overture — three lines set like a verse. Each line brightens
 * only as the reader's scroll carries it up the page, so the passage
 * is read at a sitting pace rather than skimmed.
 */
function Verse({
  children,
  className,
}: {
  children: ReactNode;
  className: string;
}) {
  const ref = useRef<HTMLParagraphElement>(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 0.92", "start 0.5"],
  });
  const opacity = useTransform(scrollYProgress, [0, 1], [0.08, 1]);
  const y = useTransform(scrollYProgress, [0, 1], [14, 0]);

  return (
    <motion.p
      ref={ref}
      className={className}
      style={reduce ? undefined : { opacity, y }}
    >
      {children}
    </motion.p>
  );
}

export function Recognition() {
  return (
    <section className="bg-cream px-7 py-28 md:py-40">
      {/* The band opens the book — a run of block-print border as the
          reader arrives from the film onto paper. */}
      <Band className="mb-20 md:mb-28" />
      <div className="mx-auto max-w-3xl space-y-10 text-center">
        <Verse className="font-display text-3xl leading-snug text-warm-brown md:text-[2.2rem]">
          You&rsquo;ve felt it.
        </Verse>

        <Verse className="font-serif text-2xl leading-relaxed text-warm-brown-light italic md:text-[1.65rem]">
          In the quiet moments — between the alarms, the deadlines, the noise.
        </Verse>

        <Verse className="font-display text-3xl leading-snug text-warm-brown md:text-[2.2rem]">
          A sense that there might be something more.
        </Verse>
      </div>
    </section>
  );
}
